import { Component, Vue } from "vue-property-decorator";
import Cookies from 'js-cookie';

import { AnnouncementModel, LoginModel } from "@/models";
import { Loading, Nav, Title, BlankPage, Pagination, LightBoxFirstTime, LightBoxOverOneYear, Hint } from "@/components";
import { TCBReceiptApi } from "@/network/pb/proto";
import { FirstTimeLogin } from "@/types/Login";
import { Common } from "@/constant";

import { Priv } from "@/util/Priv";

@Component<AnnouncementListController>({
  components: {
    Loading,
    Nav,
    Title,
    BlankPage,
    Pagination,
    LightBoxFirstTime,
    LightBoxOverOneYear,
    Hint,
  }
})
export default class AnnouncementListController extends Vue {
  private isLoading = true;

  // 元件
  private expireTime = 0;
  private minDate = "";
  private maxDate = "";

  private search: {
    enable: boolean;
    name: string;
    start: string;
    end: string;
  } = {
      enable: false,
      name: "",
      start: "",
      end: "",
    };

  // 列表
  private announcementList: TCBReceiptApi.Protobuf.IAnnouncement[] = [];

  private pagination: {
    current: number;
    total: number;
    limit: number;
  } = {
      current: 1,
      total: 0,
      limit: 10
    };

  // 初次登入LB
  private firstTimeLightBox: {
    show: boolean,
    type: number,
  } = {
      show: false,
      type: 1, // {1: 初次登入, 2: 超過一年}
    };

  // 超過一年LB
  private overOneYearLightBox: {
    show: boolean,
    firstPTag: string,
    secondPTag: string,
    keepButton: string,
    resetButton: string,
  } = {
      show: false,
      firstPTag: "",
      secondPTag: "",
      keepButton: "",
      resetButton: "",
    };

  // Hint
  private notDone = false;
  private hintBox: { show: boolean, hint: string } = { show: false, hint: "" };

  public async created() {
    /* 取得最新的權限map並判斷有何權限 */
    await this.setPriv();
    /* 取得最新的權限map並判斷有何權限 */

    const d = new Date().toISOString().split("T")[0] as string;
    this.search.start = d;
    this.search.end = d;

    // 直接預設搜尋當日公告
    await this.searchByCondition();

    // 登入狀態
    const loginType = Cookies.get("loginType");
    // E2EE狀態
    const e2eeFlag = Cookies.get("e2eeFlag");
    console.log("e2eeFlag=>"+e2eeFlag);

    if (loginType) {
      // loginType: { 1: 初次登入, 2: 一般登入, 3: 超過一年未變更密碼 }
      switch (loginType) {
        case "1":
          console.log("####初次登入####");
          this.firstTimeLightBox.show = true;
          break;
        case "2":
          console.log("####一般登入####");
          if(e2eeFlag!="1"){            
            this.firstTimeLightBox.show = true;
            this.firstTimeLightBox.type = 1211; //E2EE
          }
          break;
        case "3":
          console.log("####超過一年未變更密碼####");
          if(e2eeFlag!="1"){            
            this.firstTimeLightBox.show = true;
            this.firstTimeLightBox.type = 1211; //E2EE
          }
          else{
            this.openOverOneYearLightBox();
          }
          break;
        default:
          console.log("loginType");
          console.log(loginType);
      }
    }
  }

  private async getAnnouncement() {
    this.isLoading = true;

    // send value
    const item = TCBReceiptApi.Protobuf.AnnouncementQuery.create({
      releaseState: 3,
      pagination: this.getPagination(false),
    });

    const announcementQuery = TCBReceiptApi.Protobuf.AnnouncementQuery.encode(item).finish();
    await AnnouncementModel.getAnnouncement(announcementQuery);
    const announcementList = AnnouncementModel.getAnnouncementList();
    this.announcementList = announcementList.list;
    this.pagination.total = announcementList.total;

    console.log("api data");
    console.log(this.announcementList);

    this.isLoading = false;
  }

  /* 搜尋 */
  private async searchByCondition() {
    if (
      this.search.name === "" &&
      this.search.start === "" &&
      this.search.end === ""
    ) {
      this.search.enable = false;
      this.getAnnouncement();
    } else {
      this.search.enable = true;
      this.getAnnouncementByCondition(true);
    }
  }

  private async getAnnouncementByCondition(isFirstSearch: boolean) {
    this.isLoading = true;

    const item = TCBReceiptApi.Protobuf.AnnouncementQuery.create({
      releaseState: 3,
      pagination: this.getPagination(isFirstSearch),
    });

    if (this.search.name !== "") {
      item.name = this.search.name;
    }
    if (this.search.start !== "") {
      item.dateStart = this.search.start;
    }
    if (this.search.end !== "") {
      item.dateEnd = this.search.end;
    }
    item.target = 1;
    
    console.log("搜尋參數");
    console.log(item);
    const announcementQuery = TCBReceiptApi.Protobuf.AnnouncementQuery.encode(item).finish();

    if (isFirstSearch) {
      this.pagination.current = 1;
    }

    await AnnouncementModel.getAnnouncementByCondition(announcementQuery);
    const announcementList = AnnouncementModel.getAnnouncementList();
    this.announcementList = announcementList.list;
    this.pagination.total = announcementList.total;

    this.isLoading = false;
  }
  /* 搜尋 */

  /* 起訖日期 */
  private bindDatePeriod() {
    // if (
    //   new Date(this.search.start).getTime() >
    //   new Date(this.search.end).getTime()
    // ) {
    //   this.search.end = this.search.start;
    // }

    // const day = new Date(this.search.start);

    // this.minDate = day.toISOString().split("T")[0];
    // day.setDate(day.getDate() + 31);
    // this.maxDate = day.toISOString().split("T")[0];

    // if (
    //   (new Date(this.search.end).getTime() - new Date(this.search.start).getTime()) >= 86400 * 31 * 1000
    // ) {
    //   this.search.end = day.toISOString().split("T")[0];
    // }
  }
  /* 起訖日期 */

  /* Pagination */
  private prev() {
    this.pagination.current--;

    if (this.search.enable) {
      this.getAnnouncementByCondition(false);
    } else {
      this.getAnnouncement();
    }
  }

  private next() {
    this.pagination.current++;

    if (this.search.enable) {
      this.getAnnouncementByCondition(false);
    } else {
      this.getAnnouncement();
    }
  }

  private to(specificPagination: number) {
    this.pagination.current = specificPagination;

    if (this.search.enable) {
      this.getAnnouncementByCondition(false);
    } else {
      this.getAnnouncement();
    }
  }

  private getPagination(isSearch: boolean) {
    const offset = isSearch
      ? 0
      : this.pagination.limit * (this.pagination.current - 1);

    const pagination = TCBReceiptApi.Protobuf.Pagination.create({
      limit: this.pagination.limit,
      offset: offset
    });

    return pagination;
  }
  /* Pagination */

  /* FirstTimeLightBox */
  private async submitFirstTimeLightBox(form: TCBReceiptApi.Protobuf.PasswordMotify) {
    console.log(form);

    this.firstTimeLightBox.show = false;
    this.isLoading = true;

    /* send value */
    const item = form as TCBReceiptApi.Protobuf.PasswordMotify;
    console.log(item);
    const passwordMotifyQuery = TCBReceiptApi.Protobuf.PasswordMotify.encode(item).finish();
    const errorCode = await LoginModel.firstResetPassword(passwordMotifyQuery);
    console.log(errorCode);

    if (errorCode === TCBReceiptApi.Protobuf.ErrorCode.EC_SUCESS) {
      this.notDone = false;
      this.openHint("設定完成");
      
      // 移除登入狀態
      Cookies.remove("loginType");
      Cookies.remove("e2eeFlag");
    } else {
      this.notDone = true;

      switch(errorCode) {
        case TCBReceiptApi.Protobuf.ErrorCode.EC_PASSWORD_LENGTH_ERROR:
          this.openHint("密碼不應少於六位");
          break;
        case TCBReceiptApi.Protobuf.ErrorCode.EC_PASSWORD_FORMAT_ERROR:
          this.openHint("密碼格式錯誤");
          break;
        case TCBReceiptApi.Protobuf.ErrorCode.EC_SAME_PASSWORD_ERROR:
          this.openHint("密碼不應與用戶代號(統編或特店代號)、使用者代號相同");
          break;
        case TCBReceiptApi.Protobuf.ErrorCode.EC_OLD_PASSWORD_ERROR:
          this.openHint("密碼不得與原密碼相同");
          break;          
        default:
          this.openHint(Common.ErrorCodeMap[errorCode]);
      }
    }
    /* send value */

    this.isLoading = false;
  }
  /* FirstTimeLightBox */

  /* OverOneYearLightBox */
  private openOverOneYearLightBox() {
    this.overOneYearLightBox = {
      show: true,
      firstPTag: "您的密碼已超過365天未更改",
      secondPTag: "請前往修改密碼以保障帳戶安全",
      keepButton: "沿用密碼",
      resetButton: "修改密碼",
    };
  }

  private async keepPwd() {
    console.log("keepPwd");
    this.overOneYearLightBox.show = false;
    this.isLoading = true;

    /* send value */
    const errorCode = await LoginModel.continuePassword();
    console.log(errorCode);

    if (errorCode === TCBReceiptApi.Protobuf.ErrorCode.EC_SUCESS) {
      this.openHint("設定完成");
    } else {
      this.openHint("設定失敗");
    }
    /* send value */

    // 移除登入狀態
    Cookies.remove("loginType");
    Cookies.remove("e2eeFlag");

    this.isLoading = false;
  }

  private async resetPwd() {
    console.log("resetPwd");
    this.overOneYearLightBox.show = false;
    this.firstTimeLightBox.show = true;
    this.firstTimeLightBox.type = 2;
  }
  /* OverOneYearLightBox */

  /* Hint */
  private openHint(hint: string) {
    this.hintBox.show = true;
    this.hintBox.hint = hint;
  }

  private closeHint() {
    if (this.notDone) {
      this.firstTimeLightBox.show = true;
    }
    this.hintBox.show = false;
    this.hintBox.hint = "";
  }
  /* Hint */

  /* 取得最新的權限map並判斷有何權限 */
  private async setPriv() {
    await Priv._checkPriv();
    this.expireTime = Priv._getExpireTime();
  }
  /* 取得最新的權限map並判斷有何權限 */
}
